import { FC } from "react";
import { MuiBox, MuiStepper, MuiTypography } from "../../../../components";
import { BULK_TYPE, SummaryStatus } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { transferSteps, transferTypeKey } from "../../modelsAndSchemas/Models";
import { bulkTransferSiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { CreateBulkTransferStepperWrapper } from "./CreateBulkTransferStepper.style";

interface CreateBulkTransferStepperProps {
  currentStep: number;
  transferType: string;
  isAllProceed?: boolean;
  status?: string;
}

export const CreateBulkTransferStepper: FC<CreateBulkTransferStepperProps> = ({
  currentStep,
  transferType,
  isAllProceed = false,
  status = "",
}) => {
  const { fetchLabel } = useSiteCore();

  const getLabel = (key: string) => {
    return fetchLabel(bulkTransferSiteCoreKeys.bulkTransferStepperKeys, key);
  };

  const getHeaderLabelValueForProcessingStep = () => {
    if (status === SummaryStatus.PROCESSING) {
      return getLabel(bulkTransferSiteCoreKeys.processingProgress);
    } else {
      return getLabel(bulkTransferSiteCoreKeys.almostThere);
    }
  };
  const getSubHeaderLabelValueForProcessingStep = () => {
    if (status === SummaryStatus.PROCESSING) {
      return getLabel(bulkTransferSiteCoreKeys.processingYourRecordsMessage);
    } else {
      return transferType === transferTypeKey.changeProgram
        ? getLabel(
            bulkTransferSiteCoreKeys.chooseCompatibleProgramTemplateMessage,
          )
        : getLabel(bulkTransferSiteCoreKeys.chooseDestinationCountryMessage);
    }
  };

  const getStepperLabels = () => {
    let header = "";
    let subHeader = "";

    switch (currentStep) {
      case transferSteps.chooseParticipants:
        header = getLabel(bulkTransferSiteCoreKeys.letsStart);
        subHeader = getLabel(bulkTransferSiteCoreKeys.chooseParticipantMessage);
        break;

      case transferSteps.transferDetails:
        header = getHeaderLabelValueForProcessingStep();
        subHeader = getSubHeaderLabelValueForProcessingStep();
        break;

      case transferSteps.success:
        header = isAllProceed
          ? getLabel(bulkTransferSiteCoreKeys.youAreDone)
          : getLabel(bulkTransferSiteCoreKeys.youAreDoneHoldOn); //sitecore added latter
        subHeader = isAllProceed
          ? ""
          : getLabel(bulkTransferSiteCoreKeys.unprocessedParticipantMessage);
        break;

      default:
        header = getLabel(bulkTransferSiteCoreKeys.letsStart);
        subHeader = getLabel(bulkTransferSiteCoreKeys.chooseParticipantMessage);
        break;
    }

    return { header, subHeader };
  };

  return (
    <CreateBulkTransferStepperWrapper data-testid="create-bulk-transfer-stepper">
      <MuiStepper
        activeStep={currentStep === 2 ? 3 : currentStep}
        steps={[
          {
            title: getLabel(bulkTransferSiteCoreKeys.participantProgressState),
          },
          {
            title:
              status === SummaryStatus.PROCESSING
                ? getLabel(bulkTransferSiteCoreKeys.processingProgress)
                : getLabel(
                    bulkTransferSiteCoreKeys.transferDetailsProgressState,
                  ),
          },

          {
            title: getLabel(bulkTransferSiteCoreKeys.successProgressState),
          },
        ]}
        bulkType={BULK_TYPE.TRANSFER}
        status={status}
      />

      <MuiBox className="stepper-content">
        <MuiTypography variant="h1Bold" className="stepper-title">
          {getStepperLabels().header}
        </MuiTypography>
        <MuiTypography
          variant="h2Bold"
          className="stepper-description"
          component="div"
        >
          {getStepperLabels().subHeader}
        </MuiTypography>
      </MuiBox>
    </CreateBulkTransferStepperWrapper>
  );
};
